// Client-side pagination bounds (#5166). The mgmt-api caps any single page at
// MaxPageSize=1000 (apps/mgmt-api/cmd/url/pagination); the SPA must never try to
// pull a whole dataset in one large request — bulk reads chunk through pages
// instead (fetchListAll). This mirrors Aura's post-ADO-5703 design, adopted
// after a single 50k pull OOM-killed the Aura prod API (ADO 5702).

// Per-request chunk; matches the server pagination MaxPageSize.
export const PAGE_CHUNK = 1000;

// Default hard cap on total records a bulk fetch will return. Fetches that hit
// it truncate loudly (toast + a marker row in the file), never silently.
export const DEFAULT_MAX_RECORDS = 5000;

// Export ceiling. Higher than DEFAULT_MAX_RECORDS because "export all clients"
// is an explicit, user-initiated bulk action (#5166 AC: verified up to 50000).
// Still chunked in PAGE_CHUNK pages, so no single large request is ever issued.
export const EXPORT_MAX_RECORDS = 50000;
